export const FORM_REQUEST_SET_PROVIDER = 'FORM_REQUEST_SET_PROVIDER' as const;
export const FORM_REQUEST_SET_PROVIDER_NAME = 'FORM_REQUEST_SET_PROVIDER_NAME' as const;
export const FORM_REQUEST_SET_FORMS = 'FORM_REQUEST_SET_FORMS' as const;
export const FORM_REQUEST_SET_PATIENT = 'FORM_REQUEST_SET_PATIENT' as const;
export const FORM_REQUEST_SET_TYPE = 'FORM_REQUEST_SET_TYPE' as const;
export const FORM_REQUEST_SET_FILE_DATA = 'FORM_REQUEST_SET_FILE_DATA' as const;
export const FORM_REQUEST_SET_AUTHORIZATION = 'FORM_REQUEST_SET_AUTHORIZATION' as const;
export const FORM_REQUEST_SET_GOVT_ID = 'FORM_REQUEST_SET_GOVT_ID' as const;
export const FORM_REQUEST_SET_SUPPORTING_DOCS = 'FORM_REQUEST_SET_SUPPORTING_DOCS' as const;
export const FORM_REQUEST_SET_PAYMENT_METHOD = 'FORM_REQUEST_SET_PAYMENT_METHOD' as const;
export const FORM_REQUEST_SET_PAYMENT = 'FORM_REQUEST_SET_PAYMENT' as const;
export const FORM_REQUEST_RESET = 'FORM_REQUEST_RESET' as const;
export const FORM_REQUEST_LOADING = 'FORM_REQUEST_LOADING' as const;
export const FORM_REQUEST_ERROR = 'FORM_REQUEST_ERROR' as const;
export const FORM_REQUEST_SET_CARD_NUMBER = 'FORM_REQUEST_SET_CARD_NUMBER' as const;
export const FORM_REQUEST_SET_CARD_TYPE = 'FORM_REQUEST_SET_CARD_TYPE' as const;
export const FORM_REQUEST_SET_REQUEST_ID = 'FORM_REQUEST_SET_REQUEST_ID' as const;
export const FORM_REQUEST_PATIENT_INFO = 'FORM_REQUEST_PATIENT_INFO' as const;
export const FORM_REQUEST_SET_REQUEST_DETAILS = 'FORM_REQUEST_SET_REQUEST_DETAILS' as const;
export const FORM_REQUEST_SET_AUTH_TYPE = 'FORM_REQUEST_SET_AUTH_TYPE' as const;
export const FORM_REQUEST_SET_ESTIMATE_AUTH = 'FORM_REQUEST_SET_ESTIMATE_AUTH' as const;
export const FORM_REQUEST_SET_SHOW_PROMPT = 'FORM_REQUEST_SET_SHOW_PROMPT' as const;
export const FORM_REQUEST_SET_RID = 'FORM_REQUEST_SET_RID' as const;
export const FORM_REQUEST_DELETE_SUPPORTING_DOC = 'FORM_REQUEST_DELETE_SUPPORTING_DOC' as const;
export const FORM_REQUEST_SET_PATIENT_FORM = 'FORM_REQUEST_SET_PATIENT_FORM' as const;
